import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api, formatApiErrorDetail } from "../lib/api";
import { TEST_IDS } from "../constants/testIds";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { SerpixWordmark } from "../components/brand/SerpixWordmark";

export default function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail));
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-50 px-6">
      <div className="w-full max-w-sm rounded-lg border border-zinc-200 bg-white p-8">
        <Link to="/" className="mb-6 inline-flex items-center gap-2">
          <SerpixWordmark size="sm" />
        </Link>
        <h1 className="mb-6 font-display text-2xl font-semibold">
          {t("auth.forgot")}
        </h1>
        {sent ? (
          <div className="rounded-md border border-blue-200 bg-blue-50 px-3 py-2 text-sm text-blue-900">
            {t("auth.reset_sent")}
            <div className="mt-3">
              <Link
                to="/reset-password"
                className="inline-block rounded-md border border-blue-300 bg-white px-3 py-1 text-xs font-medium text-blue-900 hover:bg-blue-100"
              >
                {t("auth.reset_password")} →
              </Link>
            </div>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label className="text-xs uppercase tracking-wider text-zinc-500">
                {t("auth.email")}
              </Label>
              <Input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid={TEST_IDS.forgotEmail}
                className="mt-1"
              />
            </div>
            {error && <div className="text-xs text-red-600">{error}</div>}
            <Button
              type="submit"
              data-testid={TEST_IDS.forgotSubmit}
              className="w-full bg-gradient-to-r from-[#5B4CFB] to-[#7c5cf6] text-white shadow-lg shadow-violet-500/25 hover:from-[#4f40f0] hover:to-[#6f4df0]"
            >
              {t("auth.forgot_submit")}
            </Button>
          </form>
        )}
        <Link to="/login" className="mt-6 block text-xs text-zinc-500 hover:text-zinc-900">
          ← {t("auth.login")}
        </Link>
      </div>
    </div>
  );
}
